import React, {useState} from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';

function PopBookStock(props) {
  const {open, close} = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const listItems = [
    {id: 3214, title: '수학 탄탄 교재'},
    {id: 3215, title: '수학 탄탄 교재'},
    {id: 3216, title: '수학 탄탄 교재'},
    {id: 3217, title: '수학 탄탄 교재'},
    {id: 3218, title: '수학 탄탄 교재'},
    {id: 3219, title: '수학 탄탄 교재'},
    {id: 3220, title: '수학 탄탄 교재'}
  ];
  const handleClick = (index) => {
    setSelectedItem(index);
  };
  return (
    <Modal open={open} close={close} type="com_input pop_book_stock" popSize="s">
      <h2 className="pop_tit">교재 관리</h2>
      <div className="content_container scroll">
        <ul className="com_input_sec">
          <li className="input_field">
            <div className="com_input_wrap">
              <select className="select">
                <option value="중등">중등</option>
              </select>
            </div>
          </li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <select className="select">
                <option value="2분류">2분류</option>
              </select>
              <select className="select">
                <option value="3 과목 선택">3 과목 선택</option>
              </select>
            </div>
          </li>
          <li className="input_field">
            <div className="com_input_wrap flex_row">
              <select className="select">
                <option value="4분류">4분류</option>
              </select>
              <select className="select">
                <option value="시리즈 명">시리즈 명</option>
              </select>
            </div>
          </li>
          <li className="input_field">
            <div className="check">
              <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
              <label htmlFor="rdo_01">인쇄교재</label>
              <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
              <label htmlFor="rdo_02">인쇄 /판매교재</label>
              <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
              <label htmlFor="rdo_03">파일교재</label>
            </div>
          </li>
          <li className="input_field">
            <ul className="com_scroll_list pick">
              {listItems.map((item, index) => (
                <li
                  key={index}
                  className={`item ${selectedItem === index ? 'selected' : ''}`} // 선택된 항목에 'selected' 클래스 추가
                  onClick={() => handleClick(index)}
                >
                  <span className="tit">{item.id}</span>
                  <span className="com_bar"></span>
                  <span className="tit">{item.title}</span>
                </li>
              ))}
            </ul>
          </li>
        </ul>
        <div className="com_input_upload">
          <Upload title="파일 등록" className="com_btn gray s wl" />
          <p className="file">
            <span className="txt">File name.pdf</span>
            <button type="button" className="btn_del_file" onClick={() => {}}></button>
            <button type="button" className="btn_down" onClick={() => {}}></button>
          </p>
        </div>
        <hr className="com_divider" />
        <table className="com_board_list type_row">
          <colgroup>
            <col width="148" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>전체 페이지 수</th>

              <td>
                <input type="text" className="input" defaultValue={`페이지 수 입력`} />
              </td>
            </tr>
            <tr>
              <th>발간일</th>
              <td>
                <input type="text" />
              </td>
            </tr>
            <tr>
              <th>ISBN</th>
              <td>
                <input type="text" />
              </td>
            </tr>
            <tr>
              <th>판매가</th>
              <td>
                <input type="number" className="input" />
              </td>
            </tr>
            <tr>
              <th>창고</th>
              <td>
                <select>
                  <option>선택</option>
                </select>
              </td>
            </tr>
            <tr>
              <th>노출 여부</th>
              <td>
                <div className="check">
                  <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
                  <label htmlFor="rdo_01">노출</label>
                  <input type="radio" name="rdo" id="rdo_02" className="com_chk circle" />
                  <label htmlFor="rdo_02">미노출</label>
                  <input type="radio" name="rdo" id="rdo_03" className="com_chk circle" />
                  <label htmlFor="rdo_03">미노출/절판</label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopBookStock;
